import React from "react";
import "./Contact.css";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { IoSparkles } from "react-icons/io5";

function Contact() {
  const handeClick = () => {
    window.location.href = "https://forms.gle/F5X3Shs9B58s5oE9A";
  };
  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-content">
          <span className="contact-tag">
            <IoSparkles />
            CONTACT & QUOTE
          </span>

          <h1>Get a Quote for Your Vehicle</h1>

          <p>
            Ready to give your vehicle a fresh start? Fill out the form below
            and upload a few clear photos of your vehicle. We will review its
            size and condition and contact you with a personalized quote.
          </p>

          <p>
            For the most accurate estimate, include photos of any stains, pet
            hair, scratches, swirl marks, or areas you would like us to focus
            on.
          </p>

          <button className="quote-button" onClick={handeClick}>
            Request a Quote
          </button>
        </div>

        <div className="contact-card">
          <h2>Contact The Whole 9</h2>

          <div className="contact-item">
            <FaPhoneAlt />
            <a href="tel:5856236506">585-623-6506</a>
          </div>

          <div className="contact-item">
            <FaMapMarkerAlt />
            <span>Service Area: Rochester</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
